import { Stack, StackProps as ChakraStackProps } from '@eigtech/ui-shared-dave'
import { Children, cloneElement, FC, isValidElement, ReactNode, useState } from 'react'
import { useController } from 'react-hook-form'
import { BaseProps, FormControl } from '../form-control'

/**
 * This component wraps CheckboxControl to build groups of checkboxes.
 * If you need a standalone checkbox please use CheckboxSingleControl
 * @property stackProps Chakra StackProps
 */
export interface CheckboxContainerProps extends BaseProps {
  /**
   * Chakra StackProps
   */
  stackProps?: ChakraStackProps

  /**
   * The CheckboxControl components to be rendered in this stack (required)
   */
  children: ReactNode
}

export const CheckboxContainer: FC<CheckboxContainerProps> = (props: CheckboxContainerProps) => {
  const { name, label, control, children, stackProps, ...rest } = props
  const { field } = useController({
    control,
    name,
    defaultValue: props.defaultValue || [],
  })
  const [value, setValue] = useState(field.value || [])

  const childrenWithProps = Children.map(children, (child) => {
    if (isValidElement(child)) {
      return cloneElement(child, {
        checkboxValue: value,
        setCheckboxValue: setValue,
        control,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any)
    }
    return child
  })

  return (
    <FormControl control={control} label={label} name={name} {...rest}>
      <Stack mt={1} pl={6} spacing={1} {...stackProps}>
        {childrenWithProps}
      </Stack>
    </FormControl>
  )
}

CheckboxContainer.displayName = 'CheckboxContainer'
